import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Net ROI',
      type: 'metric',
      content: {
        '{}': {
          name: 'Net ROI',
          value: {
            '{}': {
              quality: {
                if: [
                  [
                    {
                      '>': [
                        {
                          '+': {
                            '@': 'netRoiValues',
                          },
                        },
                        0,
                      ],
                    },
                    'good',
                  ],
                  [
                    {
                      '<': [
                        {
                          '+': {
                            '@': 'netRoiValues',
                          },
                        },
                        0,
                      ],
                    },
                    'bad',
                  ],
                  'neutral',
                ],
              },
              tooltip: 'Net ROI for the selected project or all projects.',
              emphasis: {
                'fmt.num': [
                  {
                    '+': {
                      '@': 'netRoiValues',
                    },
                  },
                  '$',
                ],
              },
            },
          },
          description:
            'Estimated value generated after subtracting Cursor costs.',
        },
      },
    },
  },
  subqueries: {
    netRoiValues: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'projectId',
              },
              null,
            ],
          },
          {
            in: [
              {
                '@.': [
                  '!project',
                  {
                    ref: {
                      entity: '!proj',
                    },
                  },
                ],
              },
              {
                '@>': [
                  {
                    '@$': 'projectId',
                  },
                  'ent:!projects:!proj',
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!cursor_usage_events:!cursor_usage_event',
      selection: {
        '@.': '!net_roi_usd',
      },
    },
  },
}
